import React, { Fragment } from 'react'
import theme from "js/material-ui-theme"
import { Button, Fab, makeStyles } from "@material-ui/core";
import { Add } from "@material-ui/icons"

interface IButtonPrimaryAddProps {
    onNew: () => void
    label: string
    small: boolean
}


export function ButtonPrimaryAdd(props: IButtonPrimaryAddProps) {
    const styles = useStyles();
    return (
        <Fragment>
            {
                props.small ?
                    <Fab
                        size="medium"
                        color="primary"
                        aria-label="add"
                        className={styles.fab}
                        onClick={() => {
                            props.onNew();
                        }}
                    >
                        <Add />
                    </Fab>
                    :
                    <Button
                        variant="text"
                        color="primary"
                        onClick={() => {
                            props.onNew();

                        }}
                    >
                        {props.label.toLocaleUpperCase()}
                    </Button>
            }
        </Fragment>

    )
}


const useStyles = makeStyles(() => ({
    fab: {
        position: "fixed",
        margin: "0px",
        top: "auto",
        left: "auto",
        right: theme.spacing(3),
        bottom: theme.spacing(3),
        zIndex: 1,
    }
}));
